module.exports = "/_next/static/images/desktop_microsalts_footer_banner-3824f16ff7dc70f5c7c13b40b3b44449.png";